import { render, staticRenderFns } from "./HistoryPrivilegeDetail.vue?vue&type=template&id=256cd022&scoped=true"
import script from "./HistoryPrivilegeDetail.vue?vue&type=script&lang=js"
export * from "./HistoryPrivilegeDetail.vue?vue&type=script&lang=js"
import style0 from "./HistoryPrivilegeDetail.vue?vue&type=style&index=0&id=256cd022&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256cd022",
  null
  
)

export default component.exports